export default "__VITE_ASSET__RTJk$tsJ__"